

































import {Component, Vue} from 'vue-property-decorator';

import BackToHomeCross from '@/components/BackToHomeCross.vue';
import FooterGeneral from '@/components/FooterGeneral.vue';
import HeaderVideo from '@/components/HeaderVideo.vue';
import NextPage from '@/components/NextPage.vue';

import content from '../data/contents.json';

@Component({
    components: {
        BackToHomeCross,
        FooterGeneral,
        HeaderVideo,
        NextPage,
    },
})
export default class Challenges extends Vue {
    public items: any = content.challenges;
}
